import React from 'react';
import { Link } from 'react-router-dom';
import ArrowLeft from '../../Assets/Arrow left.svg';
import TabButton from '../../Components/TabButton/TabButton';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveTab } from "../../Features/settingsSlice";
import MyProfile from './Components/MyProfile/MyProfile';
import BusinessInfo from './Components/BusinessInfo/BusinessInfo';
import ManageMembers from './Components/ManageMembers/ManageMembers';
import PaymentInfo from './Components/PaymentInfo/PaymentInfo';
import StoreInfo from './Components/StoreInfo/StoreInfo';
import Modal from './Components/Modal/Modal';

const tabs = [
    {
        id: 'myProfile',
        name: 'My Profile',
    },
    {
        id: 'businessInfo',
        name: 'Business Info',
    },
    {
        id: 'manageMembers',
        name: 'Manage Members',
    },
    {
        id: 'storeInfo',
        name: 'Store Info',
    },
    {
        id: 'paymentInfo',
        name: 'Payment Info',
    },
];

function Settings() {
    const dispatch = useDispatch();

    const activeTab = useSelector((state) => state.settings.tab);

    const updateActiveTab = (selection) => {
        dispatch(setActiveTab(selection));
    }

    return (
        <div className='w-screen flex flex-col gap-2 overflow-y-scroll no-scrollbar pb-16 h-dvh'>
            <div className="flex items-center justify-between gap-6 relative m-[20px_19px_24px_20px]">
                <div className="w-fit flex items-center">
                    <Link to='..' className="img p-[10px] flex items-center justify-center">
                        <img className='w-6 h-6 text-[#666666]' src={ArrowLeft} alt="" />
                    </Link>

                    <h1 className="p-[6px] text-[#121212] font-urbanist-regular font-bold leading-8 text-[24px]">Settings</h1>
                </div>
            </div>

            <div className="flex border-b-2 border-[#F5F5F5] m-[0px_19px_0px_20px]">
                {tabs.map(tab => {
                    return (
                        <TabButton 
                            key={tab.id} 
                            id={tab.id} 
                            optionName={tab.name} 
                            selected={activeTab} 
                            handleSelect={updateActiveTab} 
                        />
                    )
                })}
            </div>

            <div className="m-[20px_19px_24px_20px]">
                {activeTab === 'myProfile' && <MyProfile />}

                {activeTab === 'businessInfo' && <BusinessInfo />}

                {activeTab === 'manageMembers' && <ManageMembers />}

                {activeTab === 'storeInfo' && <StoreInfo />}

                {activeTab === 'paymentInfo' && <PaymentInfo />}
            </div>

            <Modal />
        </div>
    );
}

export default Settings;
